/* 模块可见性计算（与后端 _ROLE_LOCKED_MODS / MODULE_CATALOG 规则一致） */
export const ROLE_LOCKED_MODS = { pm: ["/warehouses", "/warehouses/scan", "/warehouse-audit", "/warehouse-dashboard"] };
export const isLockedMod = (base, key) => (ROLE_LOCKED_MODS[base] || []).some((k) => key === k || key.startsWith(k + "::"));

const subFits = (sm, base) => sm.roles === "*" || (sm.roles || []).includes(base);

/* 基础角色默认可见模块 = 目录默认 ∪ 角色矩阵授予 − 角色矩阵屏蔽 − 锁定；父模块可见时带上其子栏目。
   【2026-10-24 层级继承】子键继承规则与后端 _module_ok 同源：
   · 父页面在目录默认里 → 子键按各自默认角色（fits）决定；
   · 父页面被矩阵**显式授予**（roleGranted）→ 其下全部子键（栏目 + 动作按钮）一并继承可见，
     不再按子键默认角色过滤 —— 即「授权页面 = 页面 + 全部按钮」，想单独收某个按钮再显式屏蔽。 */
export function baseDefaultSet(base, modCatalog = [], subCatalog = [], roleDenied = {}, roleGranted = {}) {
  const grantedKeys = roleGranted[base] || [];
  const d = new Set(modCatalog.filter((m) => ((m.roles === "*" ? base !== "subcontractor" : (m.roles || []).includes(base)) || grantedKeys.includes(m.key)) && !(roleDenied[base] || []).includes(m.key) && !isLockedMod(base, m.key)).map((m) => m.key));
  subCatalog.forEach((sm) => { if (d.has(sm.parent) && (subFits(sm, base) || grantedKeys.includes(sm.parent))) d.add(sm.key); });
  return d;
}

/* 角色（内置或自定义）生效模块：基础默认 → 叠加自定义角色 modGranted / modDenied（用户级 modAllowed/modDenied 再在其上叠加） */
export function roleEffectiveSet(roleKey, roles = [], modCatalog = [], subCatalog = [], roleDenied = {}, roleGranted = {}) {
  const r = roles.find((x) => x.key === roleKey);
  const base = r?.baseRole || roleKey;
  const d = baseDefaultSet(base, modCatalog, subCatalog, roleDenied, roleGranted);
  if (r?.custom) {
    (r.modGranted || []).forEach((k) => { if (!isLockedMod(base, k)) { d.add(k); subCatalog.forEach((sm) => { if (sm.parent === k) d.add(sm.key); }); } });  // 显式授予 → 子键全部继承（层级继承，与后端一致）
    (r.modDenied || []).forEach((k) => { d.delete(k); subCatalog.forEach((sm) => { if (sm.parent === k) d.delete(sm.key); }); });
  }
  return d;
}

/* 目录分组：[{label, items, subs:[{label, items}]}] */
export function groupModules(modCatalog = [], zh = true) {
  const gs = [];
  modCatalog.forEach((m) => {
    const gl = zh ? (m.grp?.zh || "") : (m.grp?.en || "");
    let g = gs.find((x) => x.label === gl);
    if (!g) { g = { label: gl, items: [], subs: [] }; gs.push(g); }
    if (m.sub) {
      const sl = zh ? m.sub.zh : m.sub.en;
      let s = g.subs.find((x) => x.label === sl);
      if (!s) { s = { label: sl, items: [] }; g.subs.push(s); }
      s.items.push(m);
    } else g.items.push(m);
  });
  return gs;
}
